import moment from 'moment';

export default {
    install: (app, options) => {
        app.config.globalProperties.$modal = (key, val) => {
            switch (key) {
                case "show":
                    document.getElementById(val).classList.add("show");
                    break;
                case "hide":
                    document.getElementById(val).classList.remove("show");
                    break;
            }
        }
        app.config.globalProperties.$NODE_ENV = process.env.NODE_ENV;
        app.config.globalProperties.$VUE_APP_WS_URL = process.env.VUE_APP_WS_URL;
        app.config.globalProperties.$ENGINES = ['yandex', 'google'];
        app.config.globalProperties.$TEMPLATE = {
            orion: 'Orion',
            dr: 'DR',
            dr_bg: 'DR (тон ссылок - фон)',
            facct: 'FACCT',
            gib: 'GIB',
            sber: 'Сбер',
        };
        app.config.globalProperties.$PICTURE_TYPE = [
            {
                id: 'search',
                name: 'Блок картинки'
            },
            {
                id: 'knowledge',
                name: 'Блок знаний'
            },
            {
                id: 'preview',
                name: 'Превью'
            },
            {
                id: 'inside_carousel',
                name: 'Карусель'
            },
            {
                id: 'video_preview',
                name: 'Видео-превью'
            }
        ];
        app.config.globalProperties.$COLORS = {
            'negative_auto_new': '#ec6b0a',
            'negative': '#d50004',
            'negative_manual_offer': '#d50004',
            'negative_manual_new': '#ff003a',
            'not_negative': '#9a9a9a',
            'not_negative_auto_new': '#9a9a9a',
            'not_negative_manual_start': '#9a9a9a',
            'not_negative_manual_new': '#9a9a9a',
            'positive_manual_finish': '#dbd116',
            'positive_manual_replace': '#8729a6',
            'positive_manual_start': '#1974d2',
            'positive_manual_new': '#1974d2',
            'positive': '#228b22',
            'manual': '#2a23ff',
            'manual_new': '#2a23ff',
            'manual_auto_new': '#2a23ff',
            'manual_manual_new': '#2a23ff',
            'positive_manual_our': '#228b22',
            'positive_manual_our_derivative': '#228b22',
            'irrelevant': '#dcdcdc',
            'irrelevant_auto_new': '#dcdcdc',
            'irrelevant_manual_new': '#dcdcdc',
            'irrelevant_manual_start': '#dcdcdc',
        };
        app.config.globalProperties.$TONES = {
            'negative': {
                name: 'Нецелевой',
                full_name: 'Нецелевая',
                type_tones: {
                    'new': 'Новый', 'offer': 'Договор',
                },
                synonym: ['negative'],
                no_filter: false
            },
            'not_negative': {
                name: 'Нейтральный',
                full_name: 'Нейтральная',
                type_tones: {
                    'new': 'Новый'
                },
                synonym: ['not_negative'],
                no_filter: false
            },
            'irrelevant': {
                name: 'Нерелевант',
                full_name: 'Нерелевант',
                type_tones: {
                    'new': 'Новый', 'start': 'На старте'
                },
                synonym: ['irrelevant'],
                no_filter: false
            },
            'manual': {
                name: 'Ручная проверка',
                full_name: 'Ручная проверка',
                type_tones: {
                    'new': 'Новый'
                },
                synonym: ['manual'],
                no_filter: false
            },
            'positive': {
                name: 'Целевой',
                full_name: 'Целевая',
                type_tones: {
                    'new': 'Новый',
                    'our': 'Наш',
                    'our_derivative': 'Производная',
                    'start': 'На старте',
                    'finish': 'Добивочные',
                    'replace': 'Корректировка',
                },
                synonym: ['positive'],
                no_filter: false
            }
        };

        app.config.globalProperties.$STATES = [
            {
                id: 10,
                name: 'Топ-10'
            },
            {
                id: 20,
                name: 'Топ-20'
            },
            {
                id: 50,
                name: 'Топ-50'
            },
            {
                id: 100,
                name: 'Топ-100'
            }
        ];
        app.config.globalProperties.$TRUST = [
            {
                id: -1,
                name: 'Компроматные'
            },
            {
                id: "0",
                name: 'Непроверенные'
            },
            {
                id: 1,
                name: 'Авторитетные'
            },
            {
                id: 2,
                name: 'СМИ'
            },
            {
                id: 3,
                name: 'Гос. сайты'
            },
            {
                id: 4,
                name: 'Корпоративные сайты'
            },
            {
                id: 5,
                name: 'Иноязычные'
            },
            {
                id: 6,
                name: 'Базы данных'
            },
            {
                id: 9,
                name: 'Другое'
            }
        ];
        app.config.globalProperties.$SITE_TYPE = [
            {
                id: "biography",
                name: 'Биография'
            },
            {
                id: "news",
                name: 'Новость'
            },
            {
                id: "tag",
                name: 'Теговая страница'
            },
            {
                id: "card",
                name: 'Карточка'
            }
        ]
        app.config.globalProperties.$COURT_TYPE = [
            {
                id: 'yes',
                name: 'Да'
            },
            {
                id: 'no',
                name: 'Нет'
            },
            {
                id: 'extrajudicial',
                name: 'Внесудебная работа'
            }
        ]
        app.config.globalProperties.$DELETE_TYPES = [
            {
                id: 'not_required',
                name: 'Не требуется'
            },
            {
                id: 'delete',
                name: 'Удаление'
            },
            {
                id: 'replace',
                name: 'Замена'
            },
            {
                id: 'displacement',
                name: 'Вытеснение'
            },
            {
                id: 'additional',
                name: 'Доп. Исследование'
            }
        ]
        app.config.globalProperties.$STATUSES = [
            {
                id: 'court',
                name: 'Удалена(скрыта по суду)'
            },
            {
                id: 'delete',
                name: 'Удалена'
            },
            {
                id: 'displacement',
                name: 'Вытеснена из ТОП 20'
            },
            {
                id: 'replacement',
                name: 'Заменена на позитив'
            }
        ]
        app.config.globalProperties.$KIND_TYPES = [
            {
                id: 'auto',
                name: 'Авто'
            },
            {
                id: 'manual',
                name: 'Ручной'
            }
        ]
        app.config.globalProperties.$date_moment = (date, format) => {
            return moment(date).format(format);
        }
        app.config.globalProperties.$getTones = (type) => app.config.globalProperties.$TONES;
        app.config.globalProperties.$getTypes = (tone) => tone ? app.config.globalProperties.$TONES[tone].type_tones : {};

        app.config.globalProperties.$func = {
            hexToRgb(hex) {
                let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
                return result ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)] : [];
            },
            componentToHex(c) {
                if (c) {
                    let hex = c.toString(16);
                    return hex.length === 1 ? "0" + hex : hex;
                }
                return "00";
            },
            rgbToHex(rgb) {
                if (rgb && rgb.length === 3) {
                    const r = rgb[0], g = rgb[1], b = rgb[2]
                    return "#" + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
                }
            },

            momentDate: (date, format = "YYYY-MM-DD", default_type = false) => {
                try {
                    if (default_type) return moment(date, default_type).format(format)
                    return moment(date).format(format)
                } catch (e) {
                    return date
                }
            },
            showElement: (_id, show) => {
                const styles = document.getElementById(_id).classList;
                if (show) styles.remove('hide')
                else styles.toggle('hide')
            },
            createSearchParams: (params) => {
                const searchParams = new URLSearchParams();
                Object.entries(params).forEach(([key, values]) => {
                    if (Array.isArray(values)) {
                        values.forEach((value) => {
                            searchParams.append(key, value);
                        });
                    } else {
                        searchParams.append(key, values);
                    }
                });
                return searchParams;
            },
            dateString: (date) => {
                try {
                    return ('0' + date.getDate()).slice(-2) + '/'
                        + ('0' + (date.getMonth() + 1)).slice(-2) + '/'
                        + date.getFullYear();
                } catch (e) {
                    return date
                }
            },
            getClass: function (link, made = true) {
                let COLORS = app.config.globalProperties.$COLORS;
                let val = made ? `${link.tone}_${link.kind_type}_${link.type_tone}` : link;
                return `color: ${COLORS[val] !== undefined ? COLORS[val] : '#000000'}`;
            },
            getTrustClass: function (resource) {
                if (resource && resource.trust === -1) {
                    return "negative";
                }
            },
            isMobile() {
                if (/Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    return true
                } else {
                    return false
                }
            },
            isURL(url) {
                try {
                    return new URL(url)
                } catch (err) {
                    return false
                }
            },
            getDomain(url) {
                try {
                    let uri = new URL(url)
                    return uri.origin
                } catch (err) {
                    return url
                }
            }
        };

    },

}